/* eslint-disable */
// 编译接口
export const API_URL = 'https://restful.gaoxiaobang.com'

// 高校邦相关接口
export const HYBIRD_URL = 'https://gxb-app.gaoxiaobang.com/hybird-web'
// export const HYBIRD_URL = 'http://192.168.30.100:8088/hybird-web'

// node 服务器
// export const url = 'http://localhost:5000'
export const url = 'https://live-api.gaoxiaobang.com'





// WEBPACK FOOTER //
// ./src/config/url_config.js